import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import Box from "@mui/material/Box";
import { DataGrid, GridToolbar, GridActionsCellItem } from "@mui/x-data-grid";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/DeleteOutlined";
import { getDocuments, deleteDocument } from "../../app/actions/documents";
import { connect } from "react-redux";
import UserChatModal from "./UserChatModal";

// import { EmptyTableOverlay } from "../EmptyTableOverlay";

import Button from "@mui/material/Button";
import TextField from "@mui/material/TextField";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";

const MyDocuments = () => {
  let navigate = useNavigate();
  const [selectedDocument, setSelectedDocument] = useState(false);
  const [selectedChatDocuments, setSelectedChatDocuments] = useState([]);
  const [open, setOpen] = useState(false);

  const { user: currentUser } = useSelector((state) => state.auth);
  const { mydocuments: documents } = useSelector((state) => state.document);
  const { selectedFacility } = useSelector((state) => state.facility);

  const dispatch = useDispatch();

  useEffect(() => {
    loadContent();
  }, [selectedFacility]);

  const loadContent = () => {
    const filters = {
      ...(selectedFacility && { facility_id: selectedFacility.value }),
    };

    dispatch(getDocuments(filters));
  };

  const handleRowClick = (params) => {
    const { id } = params;
    navigate(`/document/${id}`);
  };

  const handleEditClick = (id) => () => {
    navigate(`/document/${id}`);
  };

  const handleDeleteClick = (id) => () => {
    setOpen(true);
    const document = documents.find((row) => row.id === id);
    setSelectedDocument(document);
  };

  const handleClose = () => {
    setOpen(false);
    setSelectedDocument(false);
  };

  const handleDelete = () => {
    console.log("handleDelete", selectedDocument);
    dispatch(deleteDocument(selectedDocument.id))
      .then(() => {
        handleClose();
        loadContent();
      })
      .catch(() => {});
  };

  const columns = [
    { headerName: "Document name", field: "name", width: 450 },
    {
      headerName: "Document Type",
      field: "document_type",
      width: 150,
      valueGetter: ({ value }) => {
        return value.name;
      },
    },
    {
      headerName: "Facility",
      field: "facility",
      width: 90,
      valueGetter: ({ value }) => {
        return value.name;
      },
    },
    {
      headerName: "Owner",
      field: "owner",
      width: 120,
      valueGetter: ({ value }) => {
        return value.username;
      },
    },
    {
      headerName: "Document Data",
      field: "azure_data",
      hideable: true,
      width: 130,
      valueGetter: ({ value }) => {
        var final_data = [];
        const { image_data, key_values, words } = value;

        if (image_data.length) {
          const image_data_values = image_data.map((item, id) => {
            return item.Name;
          });
          final_data = final_data.concat(image_data_values);
        }

        if (key_values.length) {
          const key_values_data = key_values.map((item, id) => {
            return `${item.key} ${item.value}`;
          });

          final_data = final_data.concat(key_values_data);
        }

        if (words.length) {
          const words_data = words.map((item, id) => {
            return item.value;
          });
          final_data = final_data.concat(words_data);
        }

        return final_data.join(" ");
      },
    },
    { headerName: "Created On", field: "created", width: 160 },
    { headerName: "Last Edited On", field: "updated", width: 160 },
    {
      field: "actions",
      type: "actions",
      headerName: "Actions",
      width: 100,
      cellClassName: "actions",
      getActions: ({ id }) => {
        return [
          <GridActionsCellItem
            icon={<EditIcon />}
            label="Edit"
            className="textPrimary"
            onClick={handleEditClick(id)}
            color="inherit"
          />,
          <GridActionsCellItem
            icon={<DeleteIcon />}
            label="Delete"
            onClick={handleDeleteClick(id)}
            color="inherit"
          />,
        ];
      },
    },
  ];

  let content;

  content = (
    <section className="documents">
      <h1>My Documents</h1>
      <Box sx={{ width: "100%" }}>
        {currentUser ? (
          <UserChatModal
            userId={currentUser.id}
            documentIds={selectedChatDocuments}
          />
        ) : (
          ""
        )}
        <DataGrid
          checkboxSelection
          onRowSelectionModelChange={(selectionModel) => {
            console.log("selectionModel", selectionModel);
            setSelectedChatDocuments(selectionModel);
          }}
          slots={{
            toolbar: GridToolbar,
            // noRowsOverlay: EmptyTableOverlay("No documents found"),
          }}
          slotProps={{
            toolbar: {
              showQuickFilter: true,
            },
          }}
          initialState={{
            columns: {
              columnVisibilityModel: {
                azure_data: false,
              },
            },
          }}
          onRowClick={handleRowClick}
          disableColumnFilter
          disableColumnSelector
          disableDensitySelector
          rows={documents}
          columns={columns}
        />
      </Box>
      <Dialog open={open} onClose={handleClose}>
        <DialogTitle>Delete {selectedDocument?.name}</DialogTitle>
        <DialogContent>
          <DialogContentText>
            Are you sure you want to delete this document?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose}>Cancel</Button>
          <Button onClick={handleDelete}>Delete</Button>
        </DialogActions>
      </Dialog>
    </section>
  );

  return content;
};
export default MyDocuments;
